/**
 * Generates a data-test-id string based on the provided parameters.
 *
 * @param {string} [str] - The main string to be transformed into a data-test-id.
 * @param {string} [postfix] - An optional postfix to be appended to the data-test-id.
 * @param {string} [prefix] - An optional prefix to be prepended to the data-test-id.
 * @returns {string | undefined} - The generated data-test-id string or undefined if the main string is not provided.
 */
export const getDataTestId = (str, postfix, prefix) => {
    if (!str)
        return undefined;
    const prefixStr = prefix ? `${prefix}-` : '';
    const postfixStr = postfix ? `-${postfix}` : '';
    return `${prefixStr}${str.trim().replace(/[:.]/g, '').replace(/ /g, '-').toLowerCase()}${postfixStr}`;
};
